// extracted by mini-css-extract-plugin
export default {"overlay":"ModalOverlay_overlay__KIDoG","modalOverlay":"ModalOverlay_modalOverlay__QNp7w"};